import { render, staticRenderFns } from "./KioskShareJobButton.vue?vue&type=template&id=5634b076"
import script from "./KioskShareJobButton.vue?vue&type=script&lang=js"
export * from "./KioskShareJobButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports